<template>
    <div v-if="showTermsModal" class="terms-modal-overlay" @click="handleOverlayClick">
      <div class="terms-modal" @click.stop>
        <div class="terms-header">
          <h2>Terms and Conditions</h2>
        </div>
        
        <div class="terms-content">
          <p class="welcome-text">
            Welcome to ProxyMed! Before you can access your account, please review and accept our terms and conditions.
          </p>
          
          <div class="terms-text">
            <h3>By using ProxyMed, you agree to:</h3>
            <ul>
              <ul>
                <li style="background-color: #ffeb3b; padding: 4px 8px; border-radius: 4px;"><strong> This tool is for training purpose only!</strong></li>
  <li>ProxyMed is exclusively directed at medical professionals and serves solely for physician training and knowledge transfer.</li>
  <li>The information contained in ProxyMed does not constitute binding diagnostic, treatment, or therapy recommendations.</li>
  <li>Patient care decisions must be made independently of the program content and are the exclusive responsibility of the user.</li>
  <li>All information obtained from ProxyMed must be critically reviewed for each individual case.</li>
  <li>Despite the biostatistical validation process underlying ProxyMed, it assumes no liability for the topicality, accuracy, completeness, or quality of the information provided.</li>

</ul>

            </ul>
            
            <!-- <p class="legal-note">
              For complete terms and conditions, please visit our 
              <a href="/terms" target="_blank">Terms of Service</a> and 
              <a href="/privacy" target="_blank">Privacy Policy</a>.
            </p> -->
          </div>
        </div>
        
        <div class="terms-footer">
          <div class="checkbox-container">
            <input 
              type="checkbox" 
              id="agreeToTerms" 
              v-model="termsAccepted"
              class="terms-checkbox"
            >
            <label for="agreeToTerms" class="checkbox-label">
              I agree to ProxyMed's Terms and Conditions and Privacy Policy
            </label>
          </div>
          
          <div class="modal-buttons">
            <button 
              @click="rejectTerms" 
              class="btn-reject"
            >
              Reject
            </button>
            <button 
              @click="acceptTerms" 
              class="btn-accept"
              :disabled="!termsAccepted"
              :class="{ disabled: !termsAccepted }"
            >
              I Agree
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { Component, Vue, Prop } from "vue-property-decorator";
  
  @Component
  export default class TermsModal extends Vue {
    @Prop({ default: false }) showModal!: boolean;
    
    showTermsModal: boolean = false;
    termsAccepted: boolean = false;
    
    mounted() {
      this.showTermsModal = this.showModal;
      // Prevent background scrolling when modal is open
      if (this.showTermsModal) {
        document.body.style.overflow = 'hidden';
      }
    }
    
    // Handle clicking outside modal - don't allow closing without choice
    handleOverlayClick() {
      // Don't close modal when clicking outside - force user to choose
      return;
    }
    
    // Accept terms
    acceptTerms() {
      if (!this.termsAccepted) return;
      
      // Store terms acceptance in localStorage for this session
      localStorage.setItem('proxymed_terms_accepted', 'true');
      localStorage.setItem('proxymed_terms_accepted_at', new Date().toISOString());
      
      this.showTermsModal = false;
      document.body.style.overflow = 'auto';
      
      // Emit event to parent component
      this.$emit('terms-accepted');
    }
    
    // Reject terms
    rejectTerms() {
      this.showTermsModal = false;
      document.body.style.overflow = 'auto';
      
      // Clear any stored terms acceptance
      localStorage.removeItem('proxymed_terms_accepted');
      localStorage.removeItem('proxymed_terms_accepted_at');
      
      // Emit event to parent component
      this.$emit('terms-rejected');
    }
    
    // Check if user has already accepted terms in this session
    static hasAcceptedTerms(): boolean {
      const accepted = localStorage.getItem('proxymed_terms_accepted');
      return accepted === 'true';
    }
    
    beforeDestroy() {
      // Clean up - restore scrolling if component is destroyed
      document.body.style.overflow = 'auto';
    }
  }
  </script>
  
  <style lang="scss" scoped>
  /* Modal Overlay */
  .terms-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(8px);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  /* Modal Container */
  .terms-modal {
    background: white;
    border-radius: 16px;
    width: 90%;
    max-width: 600px;
    max-height: 85vh;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    animation: slideUp 0.3s ease;
    display: flex;
    flex-direction: column;
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  /* Modal Header */
  .terms-header {
    background: linear-gradient(135deg, #2f45a5, #667bf2);
    color: white;
    padding: 1.5rem 2rem;
    text-align: center;
    flex-shrink: 0;
  }
  
  .terms-header h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
  }
  
  /* Modal Content */
  .terms-content {
    padding: 2rem;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }
  
  .welcome-text {
    font-size: 1.1rem;
    color: #1e293b;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
  
  .terms-text h3 {
    color: #2f45a5;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .terms-text ul {
    list-style: none;
    padding-left: 0;
    margin-bottom: 1.5rem;
  }
  
  .terms-text li {
    padding: 0.5rem 0;
    border-left: 3px solid #667bf2;
    padding-left: 1rem;
    margin-bottom: 0.5rem;
    color: #475569;
    line-height: 1.5;
  }
  
  .legal-note {
    background: #f8fafc;
    padding: 1rem;
    border-radius: 8px;
    font-size: 0.9rem;
    color: #64748b;
    line-height: 1.5;
  }
  
  .legal-note a {
    color: #2f45a5;
    text-decoration: none;
    font-weight: 500;
  }
  
  .legal-note a:hover {
    text-decoration: underline;
  }
  
  /* Modal Footer */
  .terms-footer {
    padding: 1.5rem 2rem;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
  }
  
  .checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .terms-checkbox {
    width: 18px;
    height: 18px;
    margin-right: 0.75rem;
    accent-color: #2f45a5;
    cursor: pointer;
  }
  
  .checkbox-label {
    color: #374151;
    font-weight: 500;
    cursor: pointer;
    line-height: 1.4;
  }
  
  /* Modal Buttons */
  .modal-buttons {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
  }
  
  .btn-reject,
  .btn-accept {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 100px;
  }
  
  .btn-reject {
    background: #f1f5f9;
    color: #64748b;
    border: 1px solid #e2e8f0;
  }
  
  .btn-reject:hover {
    background: #e2e8f0;
    color: #475569;
  }
  
  .btn-accept {
    background: linear-gradient(135deg, #2f45a5, #667bf2);
    color: white;
    box-shadow: 0 4px 15px rgba(47, 69, 165, 0.2);
  }
  
  .btn-accept:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(47, 69, 165, 0.3);
  }
  
  .btn-accept.disabled {
    background: #94a3b8;
    cursor: not-allowed;
    box-shadow: none;
  }
  
  /* Mobile Responsive */
  @media (max-width: 768px) {
    .terms-modal {
      width: calc(100vw - 32px);
      max-width: calc(100vw - 32px);
      max-height: 82vh;
      border-radius: 12px;
    }

    .terms-header {
      padding: 0.875rem 1.25rem;
    }

    .terms-header h2 {
      font-size: 1.2rem;
    }

    .terms-content {
      padding: 0.875rem 1.25rem;
    }

    .welcome-text {
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
    }

    .terms-text h3 {
      font-size: 0.95rem;
      margin-bottom: 0.75rem;
    }

    .terms-text li {
      font-size: 0.875rem;
      padding: 0.35rem 0 0.35rem 1rem;
      margin-bottom: 0.35rem;
    }

    .terms-footer {
      padding: 0.875rem 1.25rem;
    }

    .checkbox-container {
      margin-bottom: 0.875rem;
    }

    .checkbox-label {
      font-size: 0.875rem;
    }

    .modal-buttons {
      flex-direction: row;
      gap: 0.75rem;
    }

    .btn-reject,
    .btn-accept {
      flex: 1;
      min-width: 0;
      padding: 0.7rem 0.5rem;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 480px) {
    .terms-modal {
      width: calc(100vw - 24px);
      max-width: calc(100vw - 24px);
      max-height: 80vh;
    }

    .terms-header h2 {
      font-size: 1.1rem;
    }

    .welcome-text {
      font-size: 0.85rem;
    }

    .terms-text li {
      font-size: 0.825rem;
      padding: 0.3rem 0 0.3rem 1rem;
    }
  }
  </style>